module.exports = __webpack_public_path__ + "media/images/icons/deezer-435e23afcb3cf305c100d2577ef42688.svg";